__turbopack_context__.v({
  "appsColumn": "ZapTable-module__FOyYGq__appsColumn",
  "lastModifiedColumn": "ZapTable-module__FOyYGq__lastModifiedColumn",
  "lastRunColumn": "ZapTable-module__FOyYGq__lastRunColumn",
  "locationColumn": "ZapTable-module__FOyYGq__locationColumn",
  "statusColumn": "ZapTable-module__FOyYGq__statusColumn",
  "zapsTable": "ZapTable-module__FOyYGq__zapsTable",
});
